export function revenueToStr(str) {
    if(str) return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    if(str == "0") return 0;
    return null;
}
